/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Dialog, Grid, Typography2 } from '@coursera/cds-core';

import { CoachButton } from 'bundles/ai-coach-platform/components/building-blocks';
import { useCoachChatContext } from 'bundles/ai-coach-platform/components/patterns/chat/context/CoachChatContext';
import { getFeatureNameLabels } from 'bundles/ai-coach-platform/utils/brandLabels';

import _t from 'i18n!nls/ai-coach-platform';

type Props = {
  isOpen: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  brandLabel?: string;
};

export const OptOutModal = ({ isOpen, onSubmit, onCancel, brandLabel = 'Coach' }: Props): React.ReactElement => {
  const { Content, Actions, HeadingGroup } = Dialog;
  const { isBrandUpdateEnabled } = useCoachChatContext();
  const { featureNameLabelLower } = getFeatureNameLabels(isBrandUpdateEnabled, brandLabel);

  return (
    <Dialog variant="transactional" aria-describedby="dialog-content" open={isOpen} onClose={onCancel}>
      <HeadingGroup>{_t('Opt out of memory')}</HeadingGroup>
      <Content id="dialog-content">
        <Typography2
          variant="bodyPrimary"
          component="p"
          css={css`
            color: var(--cds-color-grey-700);
          `}
        >
          {_t(
            `By selecting opt-out, you will turn off #{featureNameLabelLower} remembering details from your future chats to personalize your experience.
            You can delete the memories #{featureNameLabelLower} has previously saved in Memory setting. Otherwise they will remain saved.`,
            { featureNameLabelLower }
          )}
        </Typography2>
      </Content>

      <Actions>
        <Grid container spacing={16}>
          <Grid item>
            <CoachButton variant="primary" onClick={onSubmit}>
              {_t('Opt out')}
            </CoachButton>
          </Grid>
          <Grid item>
            <CoachButton variant="secondary" onClick={onCancel}>
              {_t('Cancel')}
            </CoachButton>
          </Grid>
        </Grid>
      </Actions>
    </Dialog>
  );
};

export default OptOutModal;
